export const SignStateArr = [
    {label:'签署中',value:0},
    {label:'签署完成',value:1},
    {label:'拒绝签署',value:2},
    {label:'解除中',value:3},
    {label:'解除完成',value:4},
    {label:'拒绝解除',value:5},
    {label:'已撤回',value:6},
]